import React from 'react'
import Animation from 'components/Slides/Animation'

export default Animation({
  animationData: require('../code/loop.json'),
  bgColor: '#003EEA',
})



// WEBPACK FOOTER //
// ./src/slides/wordpress/cool-mat-week-2/slides/05-loops.js